import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/about/page.tsx")